import UIAccordionItem from 'UIComponents/accordion/UIAccordionItem';
import styled, { theme } from 'academy-common-lib/utils/Styling';
import { getSectionBackgroundStyle } from '../sectionStyles';
import UICardWrapper from 'UIComponents/card/UICardWrapper';
import UICardSection from 'UIComponents/card/UICardSection';
import { H2 } from 'UIComponents/elements/headings';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { isPrerenderAgent } from '../../../utils/prerender';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TranscriptSection = styled.section.withConfig({
  displayName: "PublicPageTranscriptSection__TranscriptSection",
  componentId: "sc-1jswn0u-0"
})(["padding:24px 0;", ""], getSectionBackgroundStyle(theme.colors.GYPSUM));
const PublicPageTranscriptSection = ({
  transcript,
  title,
  contentType
}) => {
  return /*#__PURE__*/_jsxs(TranscriptSection, {
    children: [/*#__PURE__*/_jsx(H2, {
      className: "m-bottom-6",
      style: {
        textAlign: 'center'
      },
      children: contentType === 'LESSON' ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: "academyPublic.transcript.lessonTranscript"
      }) : /*#__PURE__*/_jsx(FormattedMessage, {
        message: "academyPublic.transcript.courseTranscript"
      })
    }), /*#__PURE__*/_jsx(UICardWrapper, {
      children: /*#__PURE__*/_jsx(UICardSection, {
        className: "p-bottom-2",
        children: /*#__PURE__*/_jsx(UIAccordionItem, {
          defaultOpen: isPrerenderAgent(),
          size: "medium",
          title: title,
          titleClassName: "m-bottom-8",
          children: /*#__PURE__*/_jsx("div", {
            className: "m-bottom-8",
            dangerouslySetInnerHTML: {
              __html: transcript
            }
          })
        })
      })
    })]
  });
};
export default PublicPageTranscriptSection;